import { heroLead, leadList } from "@/mocks/homeNews";
import { MetaRow, Tag } from "./bits";

export default function Hero() {
  return (
    <section id="lead" className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        {/* 头条栏目标签 */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <h1 className="flex items-center gap-3 font-heading text-lg md:text-xl font-bold text-foreground-950">
            <span className="flex h-6 items-center gap-2 px-2.5 rounded bg-primary-600 text-background-50 text-xs font-bold tracking-widest whitespace-nowrap">
              头版头条
            </span>
            <span className="hidden sm:block text-foreground-600 text-sm font-normal">
              每日黑料曝光台 · 今日精选第一屏
            </span>
          </h1>
          <span className="inline-flex items-center gap-2 text-xs text-foreground-600">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center" />
            榜单持续刷新中，抢在别人之前吃瓜
          </span>
        </div>

        {/* 双栏文 + 图对开 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* 左：大图头条 */}
          <article className="lg:col-span-7 group cursor-pointer">
            <div className="relative overflow-hidden rounded-lg bg-background-100">
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={heroLead.image}
                  alt={heroLead.title}
                  title={`${heroLead.title} | 每日黑料`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <Tag label={heroLead.tag} tone={heroLead.tagTone || "primary"} />
                  <span className="rounded-md bg-black/50 px-2 py-0.5 text-[11px] font-medium text-white backdrop-blur whitespace-nowrap">
                    {heroLead.time}
                  </span>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h2 className="font-heading text-xl md:text-3xl font-bold text-white leading-snug max-w-2xl">
                  {heroLead.title}
                </h2>
                <p className="mt-3 hidden sm:block text-sm text-white/85 leading-relaxed line-clamp-2 max-w-2xl">
                  {heroLead.summary}
                </p>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between">
              <span className="text-xs text-foreground-600">{heroLead.reads}阅读</span>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:gap-2 transition-all">
                点开看完整复盘 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </span>
            </div>
          </article>

          {/* 右：文字速览列 */}
          <aside className="lg:col-span-5 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="flex items-center justify-between border-b border-background-200 bg-background-100/70 px-4 py-3">
                <span className="inline-flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-flashlight-fill w-4 h-4 flex items-center justify-center text-accent-500" />
                  今日头条速览
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-blink" />
                  持续更新
                </span>
              </div>
              <div className="divide-y divide-background-200">
                {leadList.map((s, i) => (
                  <a
                    key={s.id}
                    href="#dujia"
                    className="group block cursor-pointer p-4 transition-colors hover:bg-background-100"
                  >
                    <div className="flex items-start gap-3">
                      <span className="mt-0.5 font-heading text-2xl font-bold text-secondary-300 group-hover:text-primary-500 transition-colors w-6 text-center">
                        {i + 1}
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm md:text-[15px] font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                          {s.title}
                        </p>
                        <div className="mt-2 flex items-center gap-2">
                          <Tag label={s.tag} tone={s.tagTone || "secondary"} />
                          <span className="text-xs text-foreground-600 whitespace-nowrap">{s.time}</span>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* 顶部编辑精选小卡 */}
            <div className="hidden lg:block rounded-lg bg-primary-600 text-background-50 p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-bold tracking-widest text-accent-200 whitespace-nowrap">
                  本日小编精选
                </span>
                <span className="text-[11px] text-background-50/80">第 0726 期</span>
              </div>
              <p className="text-sm leading-relaxed text-background-50/95">
                从数十条爆料里挑出这一条最值得你抢看的，已经帮你在时间线上排好顺序，别刷太快看漏了。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}